// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__PxTGy","tab":"Tabs_tab__0MfF7","selected":"Tabs_selected__D5hdc","indicator":"Tabs_indicator__PmYUD"};